import { API_BASE_URL } from "../config/apiConfig";

// Fetch all companies
export const fetchCompanies = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/company`);
        if (!response.ok) {
            throw new Error("Failed to fetch companies");
        }
        return await response.json();
    } catch (error) {
        console.error("Error fetching companies:", error);
        throw error;
    }
};

// Fetch a single company by ID
export const fetchCompanyById = async (id) => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/companies/${id}`);
        if (!response.ok) {
            throw new Error(`Failed to fetch company with ID: ${id}`);
        }
        return await response.json();
    } catch (error) {
        console.error(`Error fetching company with ID ${id}:`, error);
        throw error;
    }
};

// Create a new company
export const createCompany = async (companyData) => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/company`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(companyData),
        });

        if (!response.ok) {
            throw new Error("Failed to create company");
        }

        return await response.json();
    } catch (error) {
        console.error("Error creating company:", error);
        throw error;
    }
};

// Update a company by ID
export const updateCompany = async (id, updatedData) => {
    console.log(updatedData)
    
    try {
        const response = await fetch(`${API_BASE_URL}/api/company/companies/${id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(updatedData),
        });

        if (!response.ok) {
            throw new Error(`Failed to update company with ID: ${id}`);
        }

        return await response.json();
    } catch (error) {
        console.error(`Error updating company with ID ${id}:`, error);
        throw error;
    }
};

// Delete a company by ID
export const deleteCompany = async (id) => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/company/${id}`, {
            method: "DELETE",
        });

        if (!response.ok) {
            throw new Error(`Failed to delete company with ID: ${id}`);
        }

        return await response.json();
    } catch (error) {
        console.error(`Error deleting company with ID ${id}:`, error);
        throw error;
    }
};